import React from 'react'
import PropTypes from 'prop-types'
import { Portal, Center, Stack, CircularProgress } from '@chakra-ui/react'

export const Loading = ({ usePortal, children, ...rest }) =>
  React.createElement(
    usePortal ? Portal : React.Fragment,
    null,
    <Stack
      as={Center}
      zIndex='1'
      position={usePortal ? 'fixed' : 'relative'}
      top='0'
      left='0'
      boxSize='100%'
      bgColor='blackAlpha.600'
      borderRadius='inherit'
      {...rest}
    >
      <CircularProgress isIndeterminate color='brand.600' />
      {children}
    </Stack>,
  )

Loading.propTypes = {
  usePortal: PropTypes.bool,
  children: PropTypes.node,
}
